if(!customElements.get('reviews-sliders')) {
  customElements.define(
    'reviews-sliders',
    class ReviewsSliders extends HTMLElement {
      mobileSliderEl = null;
      desktopSliderElements = null;
      mobileInstance = null;
      desktopInstances = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.mobileSliderEl = this.querySelector('[data-slider="mobile"]');
        this.desktopSliderElements = this.querySelectorAll('[data-slider="desktop"]');
        this.desktopInstances = [];
        this.init();
      }

      init() {
        if(!this.mobileSliderEl || !this.desktopSliderElements?.length > 0) return console.error('No reviews sliders to initiliaze');

        this.mobileInstance = new Swiper(this.mobileSliderEl, {
            slidesPerView: 1.1,
            spaceBetween: 8,
            breakpoints: {
              768: {
                slidesPerView: 2
              },
            },
            navigation: {
              prevEl: '.slider-button.mobile-reviews-slider-button.prev',
              nextEl: '.slider-button.mobile-reviews-slider-button.next',
            },
            pagination: {
              el: '.slider-pagination.mobile-reviews-slider-pagination',
              type: 'bullets',
              clickable: true
            }
          });

        let reversed = false;
        this.desktopSliderElements.forEach(sliderEl => {
          const instance = new Swiper(sliderEl, {
            loop: true,
            speed: 7000,
            autoplay: {
              delay: 0,
              reverseDirection: reversed,
              disableOnInteraction: false
            },
            initialSlide: 2,
            slidesPerView: 3,
            spaceBetween: 40,
            centered: true,
          });

          this.desktopInstances.push(instance);
          reversed = !reversed;
        });
      }
    }
  );
}